export function dataInRequest(params = {}) {
    return {
        type: '@manutconsultcorrecoes/DATA_IN_REQUEST',
        payload: { params },
    };
}

export function findData(id) {
    return {
        type: '@manutconsultcorrecoes/FIND_DATA',
        payload: { id },
    };
}

export function failedRequest() {
    return {
        type: '@manutconsultcorrecoes/FAILED_REQUEST',
    };
}

export function deleteData(id, params) {
    return {
        type: '@manutconsultcorrecoes/DELETE_DATA',
        payload: { id, params },
    };
}

export function updateData(data, params) {
    return {
        type: '@manutconsultcorrecoes/UPDATE_DATA',
        payload: { data, params },
    };
}

export function storeData(data, params) {
    return {
        type: '@manutconsultcorrecoes/STORE_DATA',
        payload: { data, params },
    };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
        type: '@manutconsultcorrecoes/SUCCESS_IN_REQUEST',
        payload: { data, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(data) {
    return {
        type: '@manutconsultcorrecoes/SUCCESS_REQUEST',
        payload: { data },
    };
}

export function successRemove(params) {
    return {
        type: '@manutconsultcorrecoes/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@manutconsultcorrecoes/RECORD_FILTERING',
        payload: { params },
    };
}
